import { IManpowerSupplyForm, IManpowerSupplyFormShort } from 'src/types/helpdesk/manpowerSupplyForm.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'helpdesk/manpower-supplies';

export const getManpowerSupplyTicket = async (id: number) => {
  return http.get<IManpowerSupplyForm>(`${controller}/${id}`);
};

export const getManpowerSupplyTicketsDropdown = async (includeProps: boolean) => {
  return http.get<IManpowerSupplyFormShort[]>(`${controller}/dropdown/overtime`, {
    params: {
      includeProps
    }
  });
};

export const getManpowerSupplies = async (ticketId: string) =>
  await http.get<IManpowerSupplyForm[]>(`${controller}/get-manpower-supply/${ticketId}`);
